import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { MessageService } from 'primeng/api';
import type { ApiResponse } from '../models';
import { extractApiErrorDetail } from '../services/http-errors.service';

/**
 * Respuestas HTTP 2xx con cuerpo tipo ApiResponse y `isSuccess: false`: toast con `message` del backend.
 */
export const apiEnvelopeErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (!(event instanceof HttpResponse)) {
          return;
        }
        const body = event.body as unknown;
        if (!body || typeof body !== 'object') {
          return;
        }
        const envelope = body as ApiResponse<unknown>;
        if (envelope.isSuccess !== false) {
          return;
        }
        const detail = extractApiErrorDetail(envelope);
        messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: detail || 'La operación no se pudo completar.',
          life: 5000,
        });
      },
    }),
  );
};
